import { computed, readonly, useHead, useState } from '#imports'

interface DialogContextState {
    dialogId: string
}

export const useDialogContext = (id?: string) => {
    const dialogs = useState<DialogContextState[]>('core:dialogs', () => [])

    const hasOpenDialogs = computed(() => !!dialogs.value.length)

    useHead({
        htmlAttrs: () => {
            return {
                class: {
                    'dialog-open': hasOpenDialogs.value
                }
            }
        }
    })

    function open() {
        if (!id) return
        // Don't add multiple instances of the same dialog
        if (dialogs.value.find(dialog => dialog.dialogId === id)) return

        // Add dialog as object with id as key to dialogs array
        dialogs.value.push({ dialogId: id })
    }

    function close() {
        // Remove dialog from dialogs array
        dialogs.value = dialogs.value.filter(dialog => dialog.dialogId !== id)
    }

    return {
        dialogs: readonly(dialogs),
        hasOpenDialogs,
        open,
        close,
    }
}
